var r=(r,e,n,l,o)=>{const s=[e&&`${r}-helper`,n&&`${r}-error`,l&&`${r}-success`,o&&`${r}-info`].filter((r=>r));return s.length?s.join(" "):null};export{r as c};
